export const SITE = {
    name: "Groszownik",
    url: "https://groszownik.io",
    slogan: "Twoja księgowość w kieszeni",
    description:
        "Aplikacja księgowa dla JDG i freelancerów w Polsce. KSeF FA-2, KPiR na autopilocie, OCR AI, AI Doradca, VAT-OSS i automatyczne QR podatków — wszystko w telefonie.",
};

export const NAV = [
    { label: "Funkcje", href: "/features" },
    { label: "Cennik", href: "/pricing" },
    { label: "AI", href: "/ai" },
    { label: "Blog", href: "/blog" },
];

export const TRUST_BADGES = [
    { icon: "ShieldCheck", label: "Zgodne z KSeF FA-2" },
    { icon: "Lock", label: "Dane szyfrowane (HMAC)" },
    { icon: "MapPin", label: "Serwery w UE — RODO" },
    { icon: "Sparkles", label: "AI, które nie uczy się na Twoich danych" },
];

export const FEATURES = [
    {
        id: "ksef",
        icon: "FileCheck2",
        title: "KSeF FA-2",
        desc: "Wysyłaj i odbieraj faktury ustrukturyzowane w Krajowym Systemie e-Faktur. Gotowe na obowiązek 2026.",
        span: "lg:col-span-2",
    },
    {
        id: "kpir",
        icon: "BookOpenCheck",
        title: "KPiR autopilot",
        desc: "Księga przychodów i rozchodów prowadzi się sama — księgowania proponuje AI, Ty zatwierdzasz.",
    },
    {
        id: "ocr",
        icon: "ScanLine",
        title: "OCR AI",
        desc: "Zrób zdjęcie paragonu lub faktury. AI odczyta kwoty, VAT i kontrahenta w sekundę.",
    },
    {
        id: "doradca",
        icon: "MessageSquareText",
        title: "AI Doradca",
        desc: "Zadaj pytanie po polsku: „ile odłożyć na ZUS?”. Otrzymasz konkretną, zrozumiałą odpowiedź.",
    },
    {
        id: "vatoss",
        icon: "Globe2",
        title: "VAT-OSS",
        desc: "Sprzedajesz w UE? Rozliczaj VAT-OSS bez arkuszy — stawki i limity pilnuje aplikacja.",
    },
    {
        id: "briefing",
        icon: "Newspaper",
        title: "AI Briefing",
        desc: "Codzienny skrót: co zapłacić, co wysłać, jakie terminy. Terminy pod kontrolą, bez ryzyka kar.",
        span: "lg:col-span-2",
    },
    {
        id: "qr",
        icon: "QrCode",
        title: "Auto QR podatków",
        desc: "Gotowy kod QR do przelewu ZUS i US z poprawną kwotą i mikrorachunkiem. Skanuj i płać.",
    },
    {
        id: "zus2026",
        icon: "CalendarClock",
        title: "ZUS Wakacje 2026",
        desc: "Zaplanuj miesiąc bez składek. Aplikacja liczy oszczędność i przypomni o wniosku.",
    },
];

export const COMING_SOON = [
    { title: "Multi-firma", desc: "Zarządzaj kilkoma JDG z jednego konta.", date: "Q3 ’26" },
    { title: "Integracje bankowe", desc: "Automatyczny import wyciągów i parowanie płatności.", date: "Q3 ’26" },
    { title: "Panel księgowego", desc: "Udostępnij dostęp swojej księgowej z pełną kontrolą.", date: "Q4 ’26" },
    { title: "Umowy i e-podpis", desc: "Generuj i podpisuj umowy z kontrahentami w aplikacji.", date: "Q4 ’26" },
    { title: "Prognoza cashflow", desc: "AI przewidzi Twoją płynność na 90 dni do przodu.", date: "Q1 ’27" },
    { title: "Web dashboard", desc: "Pełna wersja desktopowa dla większych firm.", date: "Q1 ’27" },
];

export const PRICING = [
    {
        id: "free",
        name: "FREE",
        price: "0 zł",
        period: "na zawsze",
        tagline: "Na start dla nowej JDG",
        features: [
            "Do 2 faktur / mc",
            "KSeF FA-2",
            "Kalkulatory podatkowe",
            "Zadania i przypomnienia",
        ],
        cta: "Zacznij za darmo",
        featured: false,
    },
    {
        id: "pro",
        name: "PRO",
        price: "34,99 zł",
        period: "/ miesiąc",
        tagline: "Dla aktywnych freelancerów",
        features: [
            "Faktury bez limitu",
            "KPiR autopilot + AI Doradca",
            "OCR AI bez limitu",
            "Auto QR ZUS/US",
            "VAT-OSS",
            "AI Briefing",
        ],
        cta: "Wybierz PRO",
        featured: true,
    },
    {
        id: "rok",
        name: "PRO Rocznie",
        price: "299,99 zł",
        period: "/ rok",
        tagline: "PRO taniej — płać raz w roku",
        features: [
            "Wszystko z planu PRO",
            "Oszczędzasz ok. 120 zł rocznie",
            "Priorytetowe wsparcie",
            "Gwarancja ceny przez 12 miesięcy",
        ],
        cta: "Wybierz roczny",
        featured: false,
    },
];

export const FAQ = [
    {
        q: "Czy Groszownik jest gotowy na KSeF FA-2 w 2026?",
        a: "Tak. Groszownik obsługuje faktury ustrukturyzowane w formacie FA-2 i integrację z Krajowym Systemem e-Faktur, więc obowiązkowy KSeF w 2026 roku nie będzie dla Ciebie problemem.",
    },
    {
        q: "Dla kogo jest ta aplikacja?",
        a: "Dla osób prowadzących jednoosobową działalność (JDG) i freelancerów w Polsce, którzy chcą prowadzić księgowość z telefonu, bez arkuszy kalkulacyjnych i skomplikowanych narzędzi.",
    },
    {
        q: "Czy moje dane są bezpieczne?",
        a: "Dane są szyfrowane i podpisywane HMAC, przechowywane na serwerach w Unii Europejskiej zgodnie z RODO. Modele AI nie uczą się na Twoich danych.",
    },
    {
        q: "Ile kosztuje Groszownik?",
        a: "Plan FREE jest darmowy na zawsze. Plan PRO to 34,99 zł miesięcznie z pełnym AI i fakturami bez limitu, a płacąc raz w roku (299,99 zł) oszczędzasz około 120 zł.",
    },
    {
        q: "Czy zastąpi biuro rachunkowe?",
        a: "Groszownik automatyzuje codzienne obowiązki i podpowiada decyzje, jednak nie zastępuje współpracy z biurem rachunkowym — w razie potrzeby możesz udostępnić dostęp przez panel księgowego (wkrótce).",
    },
    {
        q: "Jak działa OCR faktur?",
        a: "Robisz zdjęcie faktury lub paragonu, a AI odczytuje kwoty netto/brutto, stawki VAT i dane kontrahenta, tworząc gotowy wpis do zaakceptowania.",
    },
    {
        q: "Co wyróżnia Groszownik?",
        a: "Stawiamy na natywną aplikację mobilną, AI Doradcę w języku polskim oraz automatyczne kody QR do ZUS i US — tak, aby codzienna księgowość JDG była szybka i zrozumiała wprost z telefonu.",
    },
    {
        q: "Kiedy aplikacja będzie dostępna?",
        a: "Pracujemy nad premierą w App Store i Google Play. Zapisz się na listę oczekujących, a damy Ci znać jako pierwszym i damy dostęp z bonusem.",
    },
];
